/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { Injectable } from '@angular/core';

/**
 * Provides the PointsApiConfiguration configuration object with a given root URL.
 */
export function providePointsApiConfiguration(rootUrl: string) {
  var config = new PointsApiConfiguration();
  config.rootUrl = rootUrl;
  return {
    provide: PointsApiConfiguration,
    useValue: config
  };
}

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class PointsApiConfiguration {
  rootUrl: string = '';
}

/**
 * Parameters for `PointsModule.forRoot()`
 */
export interface PointsApiConfigurationParams {
  rootUrl?: string;
}
